import React, { useState } from "react";
import TipperTip from "./TipperTip";
import useOnClickOutside from "../../hooks/useOnClickOutside";

/**
 * @param props {object}
 * @param props.label {React.ReactNode=}
 * @param props.click {boolean=}
 * @param props.noBg {boolean=}
 * @param props.children {React.ReactNode=}
 * @param props.cy {string=}
 * @param props.inline {boolean=}
 * @return {React.JSX.Element}
 */
export default function Tipper(props) {
  const { label, click, noBg, children, cy, inline, ...rest } = props;
  const [showTooltip, setShowTooltip] = useState(false);
  const [elementClientRect, setElementClientRect] = useState(null);
  const ref = React.useRef();
  const ignoreRef = React.useRef(null);

  const toggleShow = () => {
    return showTooltip ? handleHide() : handleShow();
  };

  useOnClickOutside(
    ref,
    () => {
      click && handleHide();
    },
    ignoreRef
  );

  const handleShow = () => {
    // Force a synchronous layout update
    ref.current.firstElementChild.getBoundingClientRect();

    const elementClientRect =
      ref.current.firstElementChild.getBoundingClientRect();
    setShowTooltip(true);
    setElementClientRect(elementClientRect);
  };

  const handleHide = () => {
    setShowTooltip(false);
  };

  return (
    <>
      <div
        ref={ref}
        style={{
          position: "relative",
          display: inline ? "inline" : undefined,
        }}
        onMouseEnter={!click ? handleShow : undefined}
        onMouseLeave={!click ? handleHide : undefined}
        onClick={click ? toggleShow : undefined}
        data-cy="tipper-wrapper"
      >
        {children}
      </div>

      <TipperTip
        showTooltip={showTooltip}
        label={label}
        noBg={noBg}
        elementClientRect={elementClientRect}
        data-cy={cy || rest["data-cy"]}
        {...rest}
      />
    </>
  );
}

//Tipper.propTypes = {
//  label: PropTypes.any,
//  click: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
//  cy: PropTypes.string,
//};
